import { render, staticRenderFns } from "./GenericDialog.vue?vue&type=template&id=f4e94f20"
import script from "./GenericDialog.vue?vue&type=script&lang=js"
export * from "./GenericDialog.vue?vue&type=script&lang=js"
import style0 from "./GenericDialog.vue?vue&type=style&index=0&id=f4e94f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports